import { render } from "./AdvertCoastModal.vue?vue&type=template&id=11f2986a"
import script from "./AdvertCoastModal.vue?vue&type=script&lang=js"
export * from "./AdvertCoastModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__